/**
 * API endpoints for addons.
 * Regular and insurance addons use separate APIs.
 * Replace base paths when backend endpoints are defined.
 */

const REGULAR_ADDON_BASE = "/api/addon";
const INSURANCE_ADDON_BASE = "/api/addons-insurance";

export const regularAddonApi = {
    list: (page, limit) => `${REGULAR_ADDON_BASE}/list?page=${page}&limit=${limit}&type=regular`,
    create: () => `${REGULAR_ADDON_BASE}/create`,
    update: (id) => `${REGULAR_ADDON_BASE}/${id}`,
    delete: (id) => `${REGULAR_ADDON_BASE}/${id}`,
};

export const insuranceAddonApi = {
    list: (page, limit) => `${INSURANCE_ADDON_BASE}/list?page=${page}&limit=${limit}&carValue=1`,
    create: () => `${INSURANCE_ADDON_BASE}/create`,
    update: (id) => `${INSURANCE_ADDON_BASE}/${id}`,
    delete: (id) => `${INSURANCE_ADDON_BASE}/${id}`,
};
